import React from 'react';
import styles from '../Tabs/UserManager.module.scss';
import UserRow from './UserRow';

const UserList = ({ users, onDelete }) => {
  if (!users || users.length === 0) {
    return <div className={styles.noUsers}>No users found</div>;
  }

  return (
    <div className={styles.userManagerTable}>
      <div className={styles.tableHeader}>
        <h3>Email</h3>
        <h3>Actions</h3>
      </div>
      <div className={styles.tableRows}>
        {users.map((user) => (
          <UserRow 
            key={user._id} 
            user={user} 
            onDelete={onDelete}
          />
        ))}
      </div>
    </div>
  );
};

export default UserList;